import React from 'react';
import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '~/components/ui/Button';

interface ButtonProps {
    type: 'SMALL' | 'LARGE';
}

const SearchButton= ({ type }: ButtonProps) =>  
  type === 'LARGE' ? (
    <Button
      className="flex w-full h-full"
      variant="secondaryGradient"
      size="large"
      data-testid="search-bar-button"
      type="submit"
    >
      <FontAwesomeIcon icon={faSearch as IconProp} className="mr-2" />
      Zoeken
    </Button>
  ) : (
    <Button
      className="flex w-full h-full px-0 min-h-0 leading-none"
      variant="secondaryGradient"
      type="submit"
      aria-label="Zoeken"
    >
      <FontAwesomeIcon icon={faSearch as IconProp} className="text-sm" />
    </Button>
  );

export default SearchButton